// echarts 6 changed its default theme (palette, tooltip style, grid spacing).
// Pin our charts to the bundled v5 theme so they keep their existing look.
import "echarts/theme/v5.js";

export const ECHARTS_THEME = "v5";
